import { render, staticRenderFns } from "./UserGameCard.vue?vue&type=template&id=38fbf42a&scoped=true"
import script from "./UserGameCard.vue?vue&type=script&lang=js"
export * from "./UserGameCard.vue?vue&type=script&lang=js"
import style0 from "./UserGameCard.vue?vue&type=style&index=0&id=38fbf42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbf42a",
  null
  
)

export default component.exports